export default __webpack_public_path__ + "static/media/zuz-website-animation.0ab2766f.mp4";